<template>
  <div>
    <h4 class="block-label">Pricing Event Values:</h4>
    <div class="block-list">
      <div class="block-item" v-bind:key="key" v-for="[key, value] in varPricingEventValues">
        <div class="item-label">{{ key }}: &nbsp;</div>
        <hr class="item-dots" />
        <div class="item-value">{{ value }}</div>
      </div>
    </div>
    <hr />
    <h4 class="block-label">Pricing Computed Values:</h4>
      <div class="block-list">
      <div class="block-item" v-bind:key="key" v-for="[key, value] in varPricingComputedValues">
          <div class="item-label">{{ key }}: &nbsp;</div>
          <hr class="item-dots" />
          <div class="item-value">{{ value }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PricingDetails",
  props: {
    pricingDetails: {
      default: null,
      required: false,
    },
  },
  computed: {
    varPricingEventValues: function () {
      return Object.entries(this.pricingDetails?.pricingEventVariables || {})
        .sort(([keyA, _], [keyB, __]) => {keyA.localeCompare(keyB)});
    },
    varPricingComputedValues: function () {
      return Object.entries(this.pricingDetails?.pricingVariables || {})
          .sort(([keyA, _], [keyB, __]) => {keyA.localeCompare(keyB)});
    },
  },
};
</script>

<style scoped>
.block-label {
  text-align: left;
}

.block-list {
  row-gap: 4px;
  display: grid;
  column-gap: 64px;
  grid-template-columns: 1fr 1fr 1fr 1fr;
}

.block-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 10px;
}

.item-label {
  white-space: nowrap;
}

.item-dots {
  border: none;
  border-top: 1px dotted #ababab85;
  color: #fff;
  background-color: #fff;
  height: 1px;
  width: 100%;
  margin: 0;
}

.item-value {
  margin-left: 16px;
  white-space: nowrap;
}
</style>
